// extracted by mini-css-extract-plugin
export default {"container":"accordion_container__Owo01"};